import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import FONT_FAMILY from '../../../constants/fontFamily';
import FontFamilyHeader from '../../FontFamilyHeader';
import {
  Avatar,
  Container,
  QuestionContainer,
  QuestionText,
  UserNameContainer,
  UserNameText,
} from './styles';

function QuestionTwitch({ data, styles }) {
  const { avatar, show, text, username } = data;
  const [showContainer, setShowContainer] = useState(show);

  const fontFamilyText = FONT_FAMILY[styles?.text?.font || 'roboto'];
  const fontFamilyUsername = FONT_FAMILY[styles?.username?.font || 'roboto'];

  useEffect(() => {
    if (!show) {
      setTimeout(() => {
        setShowContainer(show);
      }, 900);
    } else {
      setShowContainer(show);
    }
  }, [show]);

  return (
    <>
      <FontFamilyHeader family={fontFamilyText} />
      <FontFamilyHeader family={fontFamilyUsername} />
      {showContainer && (
        <Container show={show}>
          <QuestionContainer style={{ background: styles?.text?.background }}>
            <QuestionText
              style={{
                color: styles?.text?.color,
                fontFamily: fontFamilyText?.family,
                fontSize: styles?.text?.size,
                letterSpacing: styles?.text?.letterSpacing,
                lineHeight: styles?.text?.size
                  ? `${styles?.text?.size + 3}px`
                  : undefined,
              }}
            >
              {text}
            </QuestionText>
          </QuestionContainer>

          <UserNameContainer
            style={{ background: styles?.username?.background }}
          >
            {avatar && <Avatar src={avatar} />}
            <UserNameText
              style={{
                color: styles?.username?.color,
                fontFamily: fontFamilyUsername?.family,
                fontSize: styles?.username?.size,
                letterSpacing: styles?.username?.letterSpacing,
                lineHeight: styles?.username?.size
                  ? `${styles?.username?.size}px`
                  : undefined,
              }}
            >
              {username}
            </UserNameText>
          </UserNameContainer>
        </Container>
      )}
    </>
  );
}

QuestionTwitch.propTypes = {
  data: PropTypes.shape({
    avatar: PropTypes.string,
    show: PropTypes.bool,
    text: PropTypes.string,
    username: PropTypes.string,
  }),
  styles: PropTypes.shape({
    text: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
    username: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
  }),
};

QuestionTwitch.defaultProps = {
  data: {
    avatar:
      'https://overlayon.s3.eu-west-3.amazonaws.com/overlayon.png',
    show: true,
    text: 'What software is being used to stream this event?',
    username: 'Anonymous',
  },
  styles: {
    text: {
      background: '#c8a4ff',
      color: '#000',
      font: 'roboto',
      letterSpacing: 0,
      size: 42,
    },
    username: {
      background: '#9147ff',
      color: '#ffffff',
      font: 'roboto',
      letterSpacing: 0,
      size: 25,
    },
  },
};

export default QuestionTwitch;
